const fabClass = 'f-action';
const fabActiveClass = 'f-action--active';

function initializeFab() {
  const fabEl = document.querySelector(`.${fabClass}`);
  if (!fabEl) return;

  const targetClass = fabEl.getAttribute('data-target');
  const targetEl = document.querySelector(`.${targetClass}`);
  let fabTimeout = null;

  function showFab() {
    fabTimeout = setTimeout(() => {
      fabEl.classList.add(fabActiveClass);
    }, 300);
  }

  function hideFab() {
    clearTimeout(fabTimeout);
    fabEl.classList.remove(fabActiveClass);
  }

  if (targetEl) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          hideFab();
        } else {
          showFab();
        }
      });
    }, {
      threshold: 0.1,
    });

    observer.observe(targetEl);
  }
}

export default {
  initialize: initializeFab,
};
